import { IsNotEmpty, IsBoolean } from "class-validator";

export class ScoreCompleteDto {
  @IsNotEmpty()
  @IsBoolean()
  complete: boolean;
}

